// frontend/src/components/landing/LandingPage.js
import React from 'react';
import { Box, GlobalStyles } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import landingTheme, { tokens } from './landingTheme';
import LandingHeader from './sections/LandingHeader';
import Hero from './sections/Hero';
import ProductShowcase from './sections/ProductShowcase';
import CitationStrip from './sections/CitationStrip';
import ThreeSteps from './sections/ThreeSteps';
import TwoLenses from './sections/TwoLenses';
import ResearchTeams from './sections/ResearchTeams';
import CtaBand from './sections/CtaBand';
import LandingFooter from './sections/LandingFooter';

// Public landing page for signed-out visitors (YES-276; design: docs/figures/wf-landing-public.png).
// Brings its own header, footer and theme, so it renders outside the app Layout.
const LandingPage = () => (
    <ThemeProvider theme={landingTheme}>
        <GlobalStyles
            styles={{
                '@media (prefers-reduced-motion: no-preference)': { html: { scrollBehavior: 'smooth' } },
            }}
        />
        <Box
            sx={{
                bgcolor: tokens.paper,
                color: tokens.ink,
                fontFamily: tokens.body,
                minHeight: '100vh',
                WebkitFontSmoothing: 'antialiased',
                overflowX: 'clip',
            }}
        >
            <Box
                component="a"
                href="#landing-main"
                sx={{
                    position: 'absolute',
                    left: 16,
                    top: -48,
                    zIndex: 20,
                    px: 2,
                    py: 1,
                    borderRadius: 2,
                    bgcolor: tokens.accent,
                    color: '#FFFFFF',
                    textDecoration: 'none',
                    '&:focus': { top: 12 },
                }}
            >
                Skip to content
            </Box>
            <LandingHeader />
            <Box component="main" id="landing-main" tabIndex={-1} sx={{ outline: 'none' }}>
                <Hero />
                <ProductShowcase />
                <CitationStrip />
                <ThreeSteps />
                <TwoLenses />
                <ResearchTeams />
                <CtaBand />
            </Box>
            <LandingFooter />
        </Box>
    </ThemeProvider>
);

export default LandingPage;
